<template>
    <form @submit.prevent="submitOutOfMarketLeadspediaForm()">
        <div class="ls-out-of-market-leadspedia-form__container grid">
            <div class="grid__col-12 ls-out-of-market-leadspedia-form__top-text">
                <h2 class="section-title">Get Free Quotes From Up to 4 Trusted Professionals</h2>
                <span
                    >Fill in the below details to get free estimates from the best local
                    professionals near you.</span
                >
            </div>
            <div class="ls-out-of-market-leadspedia-form--divider"></div>

            <div class="grid__col-12">
                <slot></slot>
            </div>
            <div class="grid">
                <div class="grid__col-12">
                    <h2
                        class="ls-condensed section-title"
                        :class="{
                            'ls-out-of-market-leadspedia-form--invalid': validation.servicesInvalid,
                        }"
                    >
                        What services are you interested in?
                    </h2>
                </div>
                <div
                    class="grid__col-xs-12"
                    :class="{
                        'grid__col-sm-10': isLawnStarter,
                        'grid__col-sm-12': isLawnLove || isHomeGnome,
                    }"
                >
                    <div class="ls-out-of-market-leadspedia-form__outer-container ls-button-picker">
                        <div
                            v-for="(service, idx) in services"
                            :key="`${idx} - ${service.id}`"
                            class="ls-out-of-market-leadspedia-form__inner-container ls-margin--top"
                        >
                            <label
                                class="ls-button ls-button--block ls-button--checkbox"
                                :class="{
                                    'ls-button--green ls-button--faded': service.selected,
                                }"
                            >
                                <input type="checkbox" @change="updateServices({ idx })" />
                                <span class="ls-button-toggle-icon">
                                    <branded-checkbox :is-active="service.selected" />
                                </span>
                                <span>{{ service.name }}</span>
                            </label>
                        </div>

                        <div
                            v-if="services[withChildrenIdx].selected"
                            class="ls-out-of-market-leadspedia-form--child-services-wrapper"
                        >
                            <span
                                class="ls-bold ls-uppercase"
                                :class="{
                                    'll-color-primary': isLawnLove || isHomeGnome,
                                    'ls-color--green--color-dodge': isLawnStarter,
                                    'ls-out-of-market-leadspedia-form--invalid':
                                        validation.withChildrenInvalid,
                                }"
                                data-font-size="0"
                                >CHOOSE {{ services[withChildrenIdx].name }} TYPE</span
                            >
                            <div
                                v-for="(childService, childIdx) in services[withChildrenIdx]
                                    .child_services"
                                :key="childService.str_id"
                                class="ls-margin--top"
                            >
                                <label class="ls-checkbox">
                                    <input
                                        type="checkbox"
                                        @change="updateServices({ idx: withChildrenIdx, childIdx })"
                                    />
                                    <branded-checkbox
                                        :is-active="childService.selected"
                                        :is-big-icon="true"
                                    />
                                    <span data-font-size="-1">{{ childService.name }}</span>
                                </label>
                                <div
                                    v-if="childService.selected && childService.notes_required"
                                    class="ls-input__wrapper"
                                    :class="{ 'ls-padding--right': !screenSize.xs }"
                                >
                                    <textarea
                                        id="child-notes"
                                        v-model="childService.notes"
                                        v-ls-track.change="{
                                            target: `out-of-market-leadspedia-form--${childService.str_id}-notes`,
                                            attachValue: true,
                                        }"
                                        class="ls-input"
                                        type="textbox"
                                        rows="2"
                                        :class="{
                                            'ls-invalid': validation.childNotesInvalid,
                                        }"
                                        @change="updateChildNotesValidation"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ls-out-of-market-leadspedia-form--divider"></div>

            <div class="grid">
                <div class="grid__col-12">
                    <h2
                        class="ls-condensed section-title"
                        :class="{
                            'ls-out-of-market-leadspedia-form--invalid': validation.budgetInvalid,
                        }"
                    >
                        Additional Details
                    </h2>
                </div>

                <div
                    :class="{
                        'grid__col-sm-10': isLawnStarter,
                        'grid__col-sm-12': isLawnLove || isHomeGnome,
                    }"
                >
                    <label class="ls-label ls-margin--top" for="notes"
                        >Other details about what you need</label
                    >
                    <div class="ls-input__wrapper" :class="{ 'ls-padding--right': !screenSize.xs }">
                        <textarea
                            id="notes"
                            v-model="notes"
                            v-ls-track.change="{
                                target: 'out-of-market-leadspedia-form--notes',
                                attachValue: true,
                            }"
                            class="ls-input"
                            type="textbox"
                            rows="3"
                            testID="notes"
                        ></textarea>
                    </div>

                    <label class="ls-label ls-margin--top" for="budget">Budget</label>
                    <div
                        class="ls-input__wrapper for-select"
                        :class="{ 'ls-margin--right': !screenSize.xs }"
                    >
                        <select
                            id="budget"
                            v-model="budget"
                            v-ls-track.change="{
                                target: 'out-of-market-leadspedia-form--budget',
                                attachValue: true,
                            }"
                            class="ls-input"
                            testID="budget"
                            :class="{ 'ls-invalid': validation.budgetInvalid }"
                            @change="updateBudgetValidation"
                        >
                            <option :value="{}" selected disabled>- Select -</option>
                            <option
                                v-for="budget in budgetOptions"
                                :key="budget.label"
                                :value="budget.value"
                            >
                                {{ budget.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="ls-out-of-market-leadspedia-form--divider"></div>
        </div>

        <ls-panel class="ls-border-all ls-border-top-none ls-out-of-market-contact-form__container">
            <ls-contact-info :title="'How can we get in touch with you?'"></ls-contact-info>
            <ls-error></ls-error>

            <div slot="button" class="grid">
                <div class="grid__col-12 ls-margin--top">
                    <button
                        v-ls-track.click="{
                            target: 'out-of-market-leadspedia-form--submit',
                        }"
                        :class="{
                            'ls-button ls-button--block ls-button--lg ls-margin--top': true,
                            'll-button-primary': isLawnLove || isHomeGnome,
                            'ls-button--yellow': isLawnStarter,
                        }"
                        type="submit"
                        :disabled="orderServiceLead.loadingStatus.isUpdating"
                    >
                        <span v-if="orderServiceLead.loadingStatus.isUpdating"
                            ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Submitting</span
                        >
                        <span v-else>GET FREE QUOTES</span>
                    </button>
                </div>
            </div>
            <div class="ls-out-of-market-leadspedia-form__disclosure grid__col-12">
                <span>
                    By clicking GET FREE QUOTES, I agree to {{ brand }}'s
                    <span
                        v-ls-track.click="{
                            target: 'out-of-market-leadspedia-form--open-tos-modal',
                        }"
                        class="ls-out-of-market-leadspedia-form__link"
                        test-id="tos"
                        @click.prevent.stop="openModal('termsOfService')"
                        >terms of service</span
                    >
                    and I agree that {{ brand }} or one of its
                    <a
                        :href="trustedPartnersLink"
                        target="_blank"
                        class="ls-out-of-market-leadspedia-form__link"
                    >
                        trusted partners
                    </a>
                    (including, but not limited to, Craft Jack, Modernize, Networx, or Angi) may
                    contact me by phone, SMS, or email, including for marketing purposes and through
                    automated phone technology. {{ brand }} may earn either a commission or a flat
                    amount from its partners for giving professionals the opportunity to bid on your
                    project. By using this service, I also agree to be bound by
                    <a
                        :href="angiTosLink"
                        target="_blank"
                        class="ls-out-of-market-leadspedia-form__link"
                    >
                        Angi's Terms of Service
                    </a>
                    and
                    <a
                        :href="angiPolicyLink"
                        target="_blank"
                        class="ls-out-of-market-leadspedia-form__link"
                    >
                        Privacy Policy
                    </a>
                    and
                    <a
                        :href="craftjackTosLink"
                        target="_blank"
                        class="ls-out-of-market-leadspedia-form__link"
                    >
                        Craft Jack's Terms of Service
                    </a>
                    and
                    <a
                        :href="craftjackPolicyLink"
                        target="_blank"
                        class="ls-out-of-market-leadspedia-form__link"
                    >
                        Privacy Policy
                    </a>
                    to the extent I use their services.
                </span>
            </div>
        </ls-panel>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import VueScrollTo from 'vue-scrollto';
import {
    ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA,
    ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET,
    MODAL__OPEN_MODAL,
} from '@/store/types';
import eventBusService from '@/services/event-bus.service';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import lsContactInfo from '@/components/original-mydot/contact-info/ContactInfo.vue';
import lsError from '@/components/original-mydot/error/Error.vue';
import brandMixin from '@/mixins/brand.mixin';
import brandedCheckbox from '@/components/original-mydot/branded-checkbox/BrandedCheckbox.vue';
import lsTrackService from '@/services/ls-track/ls-track.service';
import initializeTrustedForm from '@/helpers/trusted-form';

export default {
    name: 'LsOutOfMarketLeadspediaForm',
    components: {
        brandedCheckbox,
        lsPanel,
        lsContactInfo,
        lsError,
    },
    mixins: [brandMixin],
    data() {
        return {
            trustedPartnersLink: 'https://www.lawnstarter.com/blog/trusted-partners',
            angiTosLink: 'https://www.angi.com/terms#contract-skmav5s0l',
            angiPolicyLink: 'https://www.angi.com/terms#contract-h1zrnbhtx',
            craftjackTosLink: 'https://legal.craftjack.com/#craftjack-terms-and-conditions',
            craftjackPolicyLink: 'https://legal.craftjack.com/#craftjack-privacy-policy',

            // form
            services: [],
            notes: '',
            budget: {},
            budgetOptions: [],
            validation: {
                servicesInvalid: undefined,
                withChildrenInvalid: undefined,
                childNotesInvalid: undefined,
                budgetInvalid: undefined,
            },
            withChildrenIdx: null,
            childNotesIdx: null,
        };
    },
    computed: {
        ...mapState(['orderServiceLead', 'screenSize', 'contactInfo']),
    },
    methods: {
        ...mapActions({
            updateOutOfMarket: ORDER_SERVICE_LEAD__UPDATE_OUT_OF_MARKET,
            submitForm: ORDER_SERVICE_LEAD__SUBMIT_LEADSPEDIA,
            openModal: MODAL__OPEN_MODAL,
        }),
        updateServicesValidaton() {
            this.validation.servicesInvalid = !_.some(this.services, {
                selected: true,
            });
        },
        updateBudgetValidation() {
            this.validation.budgetInvalid = _.isEmpty(this.budget);
        },
        updateWithChildrenValidation({ skipDirtyCheck } = {}) {
            if (!skipDirtyCheck && _.isUndefined(this.validation.withChildrenInvalid)) {
                this.validation.withChildrenInvalid = null;
                return;
            }

            const serviceWithChildren = this.services[this.withChildrenIdx];

            this.validation.withChildrenInvalid =
                Boolean(serviceWithChildren.selected) &&
                !_.some(serviceWithChildren.child_services, {
                    selected: true,
                });
        },
        updateChildNotesValidation({ skipDirtyCheck } = {}) {
            if (!skipDirtyCheck && _.isUndefined(this.validation.childNotesInvalid)) {
                this.validation.childNotesInvalid = null;
                return;
            }
            const serviceWithChildren = this.services[this.withChildrenIdx];
            const childServiceWithNotes = serviceWithChildren.child_services[this.childNotesIdx];

            this.validation.childNotesInvalid =
                Boolean(serviceWithChildren.selected) &&
                Boolean(childServiceWithNotes.selected) &&
                childServiceWithNotes.notes === '';
        },
        checkFormValidation() {
            this.updateServicesValidaton();
            this.updateBudgetValidation();
            this.updateWithChildrenValidation({ skipDirtyCheck: true });
            this.updateChildNotesValidation({ skipDirtyCheck: true });

            return (
                !this.validation.servicesInvalid &&
                !this.validation.budgetInvalid &&
                !this.validation.withChildrenInvalid &&
                !this.validation.childNotesInvalid &&
                this.contactInfo.valid
            );
        },
        updateServices({ idx, childIdx }) {
            const selectedService = _.isNil(childIdx)
                ? this.services[idx]
                : this.services[this.withChildrenIdx].child_services[childIdx];

            if (!_.isNil(idx) && _.isNil(childIdx)) {
                lsTrackService.track({
                    type: 'change',
                    target: 'out-of-market-leadspedia-form--parent-service',
                    data: {
                        str_id: selectedService.str_id,
                    },
                });

                selectedService.selected = !selectedService.selected;

                _.forEach(this.services, (service) => {
                    if (service.name !== selectedService.name) {
                        // eslint-disable-next-line no-param-reassign
                        service.selected = false;
                    }
                });

                // always clear child services prior to potentially setting it below
                _.forEach(this.services[this.withChildrenIdx].child_services, (service) => {
                    // eslint-disable-next-line no-param-reassign
                    service.selected = false;
                });
            }

            if (!_.isNil(childIdx)) {
                lsTrackService.track({
                    type: 'change',
                    target: 'out-of-market-leadspedia-form--child-service',
                    data: {
                        str_id: selectedService.str_id,
                    },
                });

                selectedService.selected = !selectedService.selected;

                _.forEach(this.services[this.withChildrenIdx].child_services, (service) => {
                    if (service.id !== selectedService.id) {
                        // eslint-disable-next-line no-param-reassign
                        service.selected = false;
                    }
                });
            }

            this.updateServicesValidaton();

            if (idx === this.withChildrenIdx) {
                this.updateWithChildrenValidation();
                if (childIdx === this.childNotesIdx) {
                    this.updateChildNotesValidation();
                }
            }
        },
        submitOutOfMarketLeadspediaForm() {
            if (!this.checkFormValidation()) {
                eventBusService.eventBus.$emit('submitButtonClick');

                const invalidFields = _.pickBy(this.validation, (value) => value === true);

                lsTrackService.track({
                    type: 'submitLeadspediaFormInvalid',
                    data: {
                        invalidFields,
                    },
                });

                setTimeout(() => {
                    let firstInvalidInput = null;
                    const outOfMarketLeadspediaFirstElement = document.getElementsByClassName(
                        'ls-out-of-market-leadspedia-form--invalid'
                    )[0];
                    const lsInvalidFirstElement = document.getElementsByClassName('ls-invalid')[0];

                    // because we have a mix of both classes on the LsOutOfMarketLeadspediaForm component, we'll need to detect which is higher on the page if both have an invalid item
                    if (outOfMarketLeadspediaFirstElement) {
                        if (lsInvalidFirstElement) {
                            firstInvalidInput =
                                outOfMarketLeadspediaFirstElement.getBoundingClientRect().top <
                                lsInvalidFirstElement.getBoundingClientRect().top
                                    ? outOfMarketLeadspediaFirstElement
                                    : lsInvalidFirstElement;
                        } else {
                            firstInvalidInput = outOfMarketLeadspediaFirstElement;
                        }
                    } else {
                        firstInvalidInput = lsInvalidFirstElement;
                    }

                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
                return;
            }
            const trustedFormId = _.get(window, 'trustedForm.id');
            const payload = {
                notes: this.notes,
                budget: this.budget,
                services: this.services,
                trusted_form_id: trustedFormId,
            };

            this.submitForm({ payload });
        },
    },
    destroyed() {
        this.updateOutOfMarket({
            services: this.services,
            additionalDetails: {
                budget: this.budget,
                notes: this.notes,
            },
        });
    },
    created() {
        const { orderServiceLead } = this;

        this.services = _.map(orderServiceLead.outOfMarket.services, (service, idx) => {
            if (_.size(service.child_services)) {
                this.withChildrenIdx = idx;
            }

            const child_services = _.map(service.child_services, (childService, childIdx) => {
                if (childService.notes_required) {
                    this.childNotesIdx = childIdx;
                }
                return {
                    ...childService,
                    selected: Boolean(childService.selected),
                    notes: childService.notes_required ? childService.notes || '' : null,
                    notes_required: childService.notes_required,
                };
            });

            return {
                ...service,
                selected: Boolean(service.selected),
                child_services,
            };
        });

        this.notes = orderServiceLead.additionalDetails.notes;

        this.budgetOptions = _.map(orderServiceLead.outOfMarket.budgets, (budget, idx) => {
            const low = _.replace(budget.low, /\B(?=(\d{3})+(?!\d))/g, ',');
            const high = _.replace(budget.high, /\B(?=(\d{3})+(?!\d))/g, ',');
            let label = `$${low} – $${high}`;

            if (idx === 0) {
                label = `Up to $${high}`;
            } else if (idx === _.size(orderServiceLead.budgets) - 1) {
                label = `$${low}+`;
            }

            return {
                label,
                value: budget,
            };
        });

        this.budget = orderServiceLead.additionalDetails.budget;
        initializeTrustedForm();
    },
};
</script>

<style lang="scss">
.ls-out-of-market-leadspedia-form__container {
    background-color: palette(white);
    border: 1px solid #d5dbd9;
    border-bottom: none;
    // align with ls-panel
    padding: 15px 11px;

    h3 {
        padding-top: 20px;
    }

    span {
        font-size: 14px;
    }
}

.ls-out-of-market-leadspedia-form__top-text {
    display: flex;
    justify-content: center;
    align-items: center;
}

.ls-input {
    resize: none;
}

.ls-out-of-market-leadspedia-form__outer-container {
    display: flex;
    flex-wrap: wrap;
}

.ls-out-of-market-leadspedia-form__inner-container {
    flex: 0 0 auto;
    padding-right: rem(0);
    width: 50%;

    @include max-screen(breakpoint(xs, max)) {
        padding-right: 0;
        width: 100%;
    }
}

.ls-out-of-market-leadspedia-form--invalid {
    color: palette(red) !important;
}

.ls-out-of-market-leadspedia-form--divider {
    background-color: #d5dbd9;
    height: 1px;
    margin: 24px 16px 16px 16px;
    width: 100%;

    &:last-of-type {
        margin-bottom: 0;
    }
}

.ls-checkbox {
    display: flex;
    margin-left: 0;
    margin-bottom: rem(-3);
    padding-right: rem(-3);
    user-select: none;

    i {
        padding-right: rem(0);
        margin-top: 3px;
        font-size: rem(0);
    }

    span:before {
        // override spacing used elsewhere since we're using fa checkboxes
        content: '';
    }

    input {
        display: none;
    }
}

.ls-out-of-market-leadspedia-form--child-services-wrapper {
    border: 1px solid #abb8b2;
    padding: 15px;
    margin-top: 15px;
    width: 100%;
}

.ls-out-of-market-leadspedia-form__disclosure {
    font-size: 12px;
    padding-top: 24px;
}

.ls-out-of-market-leadspedia-form__link {
    color: palette(blue);
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
}
.themed-app {
    .ls-out-of-market-leadspedia-form__container {
        background-color: $theme-color-white;
        border-color: $theme-color-gray;

        span {
            font-size: 14px;
        }
    }

    .ls-out-of-market-leadspedia-form--invalid {
        color: $theme-color-red !important;
    }

    .ls-out-of-market-leadspedia-form--divider {
        background-color: $theme-color-gray;
    }

    .ls-out-of-market-leadspedia-form--child-services-wrapper {
        border-color: $theme-color-gray-dark;
    }

    .ls-out-of-market-leadspedia-form__tos {
        color: $theme-color-blue;
    }
}

.themed-lawnlove {
    .ls-out-of-market-leadspedia-form__container {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
    }

    .ls-out-of-market-contact-form__container {
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
    }

    .ls-out-of-market-leadspedia-form--child-services-wrapper {
        .ls-checkbox {
            align-items: center;
        }

        .ll-checkbox {
            margin-top: 0;
            margin-right: 5px;
        }
    }
}
</style>
